module.exports = __webpack_public_path__ + "img/收藏.27d9fb78.png";